module.exports = __webpack_public_path__ + "static/media/customer-icon.298505c1.svg";